import { Link } from '@tanstack/react-router'
import { Button } from '~/components/ui/button'

export default function NotFound() {
  return (
    <div className="grid min-h-screen place-items-center bg-plane px-6 text-ink">
      <div className="text-center">
        <p className="text-sm font-medium text-faint">404</p>
        <h1 className="mt-2 text-2xl font-semibold tracking-tight">Page not found</h1>
        <Button asChild variant="outline" className="mt-6">
          <Link to="/">Back home</Link>
        </Button>
      </div>
    </div>
  )
}
